import {isInThisCall, selectRoomCallEntry, type RoomCallEntry} from '../services/roomCallEntry';
import {useGroupCallState, useRoomCallSummary, useRtcFeatures} from './useGroupCall';
import {countCallPeople} from '../services/callPeople';

export interface RoomCallEntryOptions {
    readonly roomId: string | null | undefined;
    readonly isOneToOne: boolean;
    readonly legacyDirectAvailable: boolean;
    readonly sessionReady: boolean;
    readonly tabOwner: boolean;
    readonly busy: boolean;
}

export const useRoomCallEntry = ({roomId, isOneToOne, legacyDirectAvailable, sessionReady, tabOwner, busy}: RoomCallEntryOptions): RoomCallEntry => {
    const features = useRtcFeatures();
    const summary = useRoomCallSummary(roomId);
    const call = useGroupCallState();
    return selectRoomCallEntry({
        hasRoom: !!roomId,
        isOneToOne,
        legacyDirectAvailable,
        features,
        summary,
        peopleInCall: summary ? countCallPeople(summary.userIds) : 0,
        inThisCall: isInThisCall(call, roomId),
        tabOwner,
        sessionReady,
        busy,
    });
};
